import React, { useState } from 'react';
import ButtonBack from './images/x.png';
import WorkerAntIMG from './images/WorkForce.png';
import FighterAntIMG from './images/FighterAnt.png';
import GathererAntIMG from './images/Icon_inventory.png';
import WiseAntIMG from './images/LevelingGround.png';
import RogueAntIMG from './images/RogueAnt.png';
import ConjujerAntIMG from './images/ConjujerAnt.png';
import LockedAntIMG from './images/Lock.png';

function AntClasses({ onClose }) {

  return (
    <div className="popup-container">
      <div className="popup" id="ant-classes-container">
        <div className="popup-header-ant-classes">
          <h2>ANT CLASSES</h2>
        </div>
        <button className="button-close" onClick={onClose}>
          <img src={ButtonBack} alt="Close button" />
        </button>
        <div className="inventory-item item-potion" id="incubating-inventory"><img src={WorkerAntIMG} />
                 <div className="inventory-item-texts">
                 <p className="inventory-text">WORKER ANT</p>
                <p className="inventory-level-text">LVL:</p><p>20</p></div>
                </div>
                <div className="inventory-item item-potion" id="incubating-inventory"><img src={FighterAntIMG} />
                 <div className="inventory-item-texts">
                 <p className="inventory-text">FIGHTER ANT</p>
                <p className="inventory-level-text">LVL:</p><p>20</p></div>
                </div>
                <div className="inventory-item item-potion" id="incubating-inventory"><img src={GathererAntIMG} />
                 <div className="inventory-item-texts">
                 <p className="inventory-text">FORAGER ANT</p>
                <p className="inventory-level-text">LVL:</p><p>20</p></div>
                </div>
                <div className="inventory-item item-potion" id="incubating-inventory"><img src={WiseAntIMG} />
                 <div className="inventory-item-texts">
                 <p className="inventory-text">WISE ANT</p>
                <p className="inventory-level-text">LVL:</p><p>20</p></div>
                </div>
                <div className="inventory-item item-potion" id="incubating-inventory"><img src={RogueAntIMG} />
                 <div className="inventory-item-texts">
                 <p className="inventory-text">ROGUE ANT</p>
                <p className="inventory-level-text">LVL:</p><p>20</p></div>
                </div>
                <div className="inventory-item item-potion" id="incubating-inventory"><img src={ConjujerAntIMG} />
                 <div className="inventory-item-texts">
                 <p className="inventory-text">MAGE ANT</p>
                <p className="inventory-level-text">LVL:</p><p>20</p></div>
                </div>
        <div className="inventory-item item-potion" id="incubating-inventory"><img src={LockedAntIMG} />
                 <div className="inventory-item-texts">
                 <p className="inventory-text">TO BE REVEALED</p>
                <p className="inventory-level-text">LVL:</p><p>20</p></div>
                </div>
                <div className="inventory-item item-potion" id="incubating-inventory"><img src={LockedAntIMG} />
                 <div className="inventory-item-texts">
                 <p className="inventory-text">TO BE REVEALED</p>
                <p className="inventory-level-text">LVL:</p><p>20</p></div>
                </div>
                <div className="inventory-item item-potion" id="incubating-inventory"><img src={LockedAntIMG} />
                 <div className="inventory-item-texts">
                 <p className="inventory-text">TO BE REVEALED</p>
                <p className="inventory-level-text">LVL:</p><p>20</p></div>
                </div>
        <div className="inventory-item item-potion" id="incubating-inventory"><img src={LockedAntIMG} />
                 <div className="inventory-item-texts">
                 <p className="inventory-text">TO BE REVEALED</p>
                <p className="inventory-level-text">LVL:</p><p>20</p></div>
                </div>
      </div>
    </div>
  );
}

export default AntClasses;